import React, { Fragment } from 'react';
import Grid from '../../../../components/Grid';
import { Subscription, ProductDescription, ProductLogo, ProductSection, SUBSCRIPTION_TYPE } from './ActivationContent';
var LogglyAnalysis = "https://cdn.solarwinds.cloud/cloud-ui/assets/loggly-analysis-09dcac527aedbcab1680cd9e642fceb9.svg";
var LogglyTroubleshooting = "https://cdn.solarwinds.cloud/cloud-ui/assets/loggly-troubleshoot-3c4af6182100ed3dc0a6ae2f73cdcaea.svg";
var LogglyMonitoring = "https://cdn.solarwinds.cloud/cloud-ui/assets/loggly-monitor-c5c1484e7016d2695835cd5ce54c59c3.svg";
var LogglyLogo = "https://cdn.solarwinds.cloud/cloud-ui/assets/loggly-logo-675cc2acf8c7d95ec2fbf905d0876f06.svg";
export var LogglyContent = function LogglyContent(_ref) {
  var productStatus = _ref.productStatus;
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(ProductLogo, {
    logo: LogglyLogo
  }), /*#__PURE__*/React.createElement(ProductDescription, {
    title: "High performance log analysis and monitoring for DevOps"
  }), /*#__PURE__*/React.createElement(Grid.Row, null, /*#__PURE__*/React.createElement(ProductSection, {
    image: LogglyMonitoring,
    title: "Powerful Log Monitoring",
    content: "Use powerful search, flexible alerts, and dynamic charts and dashboards to monitor applications, system behavior, and unusual activity across the stack. Monitor key resources and metrics and eliminate issues before they affect users."
  }), /*#__PURE__*/React.createElement(ProductSection, {
    image: LogglyTroubleshooting,
    title: "Troubleshooting",
    content: "Fast troubleshooting and low MTR. Diagnose issues down to their root case by analyzing them in the context of the entire stack."
  }), /*#__PURE__*/React.createElement(ProductSection, {
    image: LogglyAnalysis,
    title: "Data Analysis",
    content: "Granular analysis through Loggly helps DevOps teams drill down into the deepest levels of log visibility to identify performance issues and errors."
  })), /*#__PURE__*/React.createElement(Subscription, {
    productName: "loggly",
    productStatus: productStatus,
    type: SUBSCRIPTION_TYPE.TRIAL
  }));
};